import { Injectable, inject } from '@angular/core';
import { EmailTemplateDialogComponent } from './email-template-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class EmailTemplateDialogService {
    private dialogRef = inject(MatDialog);


    cancel(): void {
        this.dialogRef.closeAll();
    }

    async showEmailTemplate(bccAddresses: string,
        confirmColor: 'primary' | 'warn' | 'accent' = 'primary') {
        return this.dialogRef.open(EmailTemplateDialogComponent, {
            data: {
                bccAddresses,
                confirmColor,
            },
            panelClass: 'ufla-email-copy-container',

        })
            .afterClosed()
            .toPromise();
    }
}
